import styled, { css } from "styled-components";

interface IStyledProgressRing {
  $color?: string;
  $strokeDashOffset?: number;
  $fontSize?: number;
  $roundStroke?: boolean;
}

export const StyledWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

StyledWrapper.displayName = "StyledWrapper";

export const StyledChildrenWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: inline-flex;
`;

StyledChildrenWrapper.displayName = "StyledChildrenWrapper";

export const StyledSvg = styled.svg`
  transform: rotate(-90deg);
`;

StyledSvg.displayName = "StyledSvg";

export const StyledBackgroundCircle = styled.circle<IStyledProgressRing>`
  fill: transparent;
  transition: stroke-dashoffset 0.5s linear, stroke 300ms ease-out;

  ${(props) =>
    props.$color
      ? css`
          stroke: ${props.$color};
        `
      : css`
          stroke: var(--color-theme-transparent-300);
        `}

  ${(props) =>
    props.$strokeDashOffset &&
    css`
      stroke-dashoffset: ${props.$strokeDashOffset};
    `}
`;

StyledBackgroundCircle.displayName = "StyledBackgroundCircle";

export const StyledForegroundCircle = styled.circle<IStyledProgressRing>`
  fill: transparent;
  transition: stroke-dashoffset 0.5s linear, stroke 300ms ease-out;

  ${(props) =>
    props.$roundStroke &&
    css`
      stroke-linecap: round;
    `}

  ${(props) =>
    props.$color
      ? css`
          stroke: ${props.$color};
        `
      : css`
          stroke: var(--color-secondary);
        `}

  ${(props) =>
    props.$strokeDashOffset &&
    css`
      stroke-dashoffset: ${props.$strokeDashOffset};
    `}
`;

StyledForegroundCircle.displayName = "StyledForegroundCircle";

export const StyledProgressRingPercentage = styled.text<IStyledProgressRing>`
  transform: rotate(90deg);

  ${(props) =>
    props.$color
      ? css`
          fill: ${props.$color};
        `
      : css`
          fill: var(--color-secondary);
        `}

  ${(props) =>
    props.$fontSize
      ? css`
          font-size: ${props.$fontSize}px;
        `
      : css`
          font-size: 10px;
        `}
`;

StyledProgressRingPercentage.displayName = "StyledProgressRingPercentage";
